export function getPasswordStrength(password = '') {
  const value = String(password || '');

  if (!value) {
    return { score: 0, percent: 0, label: 'Muito fraca', color: '#ef4444' };
  }

  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpecial = /[^A-Za-z0-9]/.test(value);
  const length = value.length;

  let score = 0;
  if (length >= 6) score += 1;
  if (length >= 10) score += 1;
  if (hasLower && hasUpper) score += 1;
  if (hasNumber) score += 1;
  if (hasSpecial) score += 1;

  // Normalizar para 0..4
  score = Math.max(0, Math.min(4, score - 1));

  const labels = ['Muito fraca', 'Fraca', 'Média', 'Forte', 'Muito forte'];
  const colors = ['#ef4444', '#f97316', '#f59e0b', '#22c55e', '#16a34a'];
  const percent = Math.round((score / 4) * 100);

  return {
    score,
    percent,
    label: labels[score],
    color: colors[score],
  };
}
